import React from 'react'

import { Empty as AEmpty} from 'antd'

export default function Empty({ description = 'No data'}) {
    return <AEmpty image={AEmpty.PRESENTED_IMAGE_SIMPLE} description={description}/>
}
